<template>
  <div class="query-container">
    <!-- 顶部横幅区域 -->
    <div class="header-banner">
      <img src="/static/images/ctruck/banner.png" alt="背景" class="banner-bg" />
      <div class="logo-overlay">
        <img src="/static/images/ctruck/logo.png" alt="Logo" class="header-logo" />
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="result-wrapper">
        <div class="result-box">
          <div class="result-item">
            <span class="result-label">您查询的数码为：</span>
            <span class="result-code">{{ formattedCode }}</span>
          </div>
          <div class="result-message" v-html="resultMessage"></div>
        </div>
      </div>
    </div>

    <!-- 底部二维码区域 -->
    <div class="footer-qrcode">
      <div class="qrcode-content">
        <div class="qrcode-left">
          <img src="/static/images/ctruck/wechat.png" alt="二维码" class="qrcode-image" />
        </div>
        <div class="qrcode-right">
          <div class="qrcode-text">长按左方二维码</div>
          <div class="qrcode-text">关注微信号!</div>
          <div class="qrcode-text">企业官网:</div>
          <a href="https://www.ctruck.com.cn" target="_blank" class="qrcode-url">www.ctruck.com.cn</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getAntiData } from '../../api/api'

export default {
  name: 'CTruckQuery',
  data() {
    return {
      code: '',
      resultMessage: '',
      formattedCode: '',
      eno: '138476474577'
    }
  },
  created() {
    console.log('Query组件created被调用')
    // 从路由参数获取查询参数
    const params = this.$route.query
    if (params.eno) {
      this.eno = params.eno
    }

    if (params.c) {
      this.code = params.c.substring(0, 16)
      // 格式化显示查询码（每4位加空格）
      this.formattedCode = this.code.replace(/(\w{4})(?=\w)/g, '$1 ')
      // 直接进行查询
      this.queryAnti()
    }
  },
  beforeDestroy() {
    console.log('Query组件beforeDestroy被调用')
  },
  methods: {
    queryAnti() {
      console.log('开始调用queryAnti，code:', this.code, 'eno:', this.eno)
      getAntiData(this.code, this.eno).then(res => {
        const data = res.data

        // 特殊场景：数码不存在300106
        if (data && (data.code == '300106' || data.code == 300106 || (data.data && (data.data.code == '300106' || data.data.code == 300106)))) {
          this.resultMessage = '您所查询的防伪码不存在，特别提示您谨防假冒，或核对后重新输入。'
          return
        }

        if (data == null || data.code == '500') {
          this.resultMessage = '防伪查询失败，请联系管理员'
        } else if (data.data && data.data.replyData) {
          this.resultMessage = data.data.replyData
        } else if (data.message) {
          this.resultMessage = data.message
        } else {
          this.resultMessage = '查询结果异常，请联系管理员'
        }
      }).catch(err => {
        console.error(err)
        this.resultMessage = '查询异常，请联系管理员'
      })
    }
  }
}
</script>

<style scoped>
.query-container {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

/* 顶部横幅区域 */
.header-banner {
  width: 100%;
  height: 200px;
  position: relative;
  overflow: hidden;
}

.banner-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-overlay {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
}

.header-logo {
  height: 35px;
  width: auto;
  max-width: 150px;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  padding: 30px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.result-wrapper {
  width: 100%;
  max-width: 500px;
  margin: 15px auto 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 查询结果 */
.result-box {
  width: 100%;
}

.result-item {
  margin-bottom: 15px;
  line-height: 1.6;
}

.result-label {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

.result-code {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-left: 2px;
}

.result-message {
  font-size: 15px;
  font-weight: bold;
  color: #000000;
  line-height: 1.6;
  white-space: pre-line;
}

.result-message h2 {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin: 10px 0;
}

.result-message h4 {
  font-size: 16px;
  color: #000000;
  margin: 0 0 10px 0;
}

.result-message p {
  margin: 10px 0;
  color: #000000;
}

/* 底部二维码区域 */
.footer-qrcode {
  width: 100%;
  padding: 30px 20px;
  box-sizing: border-box;
  background: #ffffff;
}

.qrcode-content {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.qrcode-left {
  flex-shrink: 0;
}

.qrcode-image {
  width: 140px;
  height: 140px;
  display: block;
}

.qrcode-right {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.qrcode-text {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  line-height: 1.2;
}

.qrcode-url {
  font-size: 18px;
  font-weight: bold;
  color: #1890ff;
  line-height: 1.2;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.3s;
}

.qrcode-url:hover {
  color: #40a9ff;
}

.qrcode-url:active {
  color: #096dd9;
}

/* 响应式调整 */
@media (max-width: 375px) {
  .header-banner {
    height: 180px;
  }

  .main-content {
    padding: 25px 15px;
  }

  .footer-qrcode {
    padding: 25px 15px;
  }

  .qrcode-image {
    width: 120px;
    height: 120px;
  }

  .qrcode-text,
  .qrcode-url {
    font-size: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CTruck/Query.vue